export const PRIVATE_TEAMS = 'private'
export const PUBLISHED_TEAMS = 'published'
export const OTHERS_TEAMS = 'others'
export const CORPORATE_TEAMS = 'corporate'
